const PartyConfigApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/party-config/get`,
  POST: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/party-config/create`,
  PUT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/party-config/update`,
  DELETE: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/party-config/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACI_SHARED_URL}/shared/party-config/download`
};

export default PartyConfigApiUrls
